import React from 'react'
import styled from 'styled-components'
import ReactCountryFlag from 'react-country-flag'

import {colors} from '../../../colors'
import {Text} from '../../index'

export interface LanguageOption {
  description: string
  onClick: () => void
  countryCode?: string
}

export interface LanguageSelectorProps {
  languageOptions: LanguageOption[]
  selectedLanguage: string
  selectedCountryCode?: string
}

const FlagWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.25);
  background-color: ${colors.system.white};
  box-sizing: border-box;
  overflow: visible;
  line-height: 0;
  flex-shrink: 0;
  margin-right: 0.75rem;
`

const FlagInner = styled.span`
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  left: 1px;
  border-radius: 50%;
  overflow: hidden;
  display: block;
  line-height: 0;
`

const LanguageSelectorModal = styled.div`
  min-width: 245px;
  color: ${colors.brand.cobalt};
  padding: 1rem;
`

const SelectItem = styled.div`
  margin: 0 3rem 1rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const OptionRow = styled.div`
  display: flex;
  align-items: center;
`

export const LanguageSelector = ({languageOptions}: LanguageSelectorProps) => {
  return (
    <LanguageSelectorModal data-cy="language-selector-modal">
      {languageOptions.map(option => (
        <SelectItem key={option.description}>
          <OptionRow>
            {option.countryCode && (
              <FlagWrapper>
                <FlagInner>
                  <ReactCountryFlag
                    countryCode={option.countryCode}
                    svg
                    style={{width: '100%', height: '100%', display: 'block', objectFit: 'cover'}}
                    aria-label={option.description}
                  />
                </FlagInner>
              </FlagWrapper>
            )}
            <Text size="M" onClick={option.onClick}>
              {' '}
              {option.description}{' '}
            </Text>
          </OptionRow>
        </SelectItem>
      ))}
    </LanguageSelectorModal>
  )
}
